import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';

@Injectable()
export class PermissionQueryService {
  public GET_ALL_STATUS: any;
  public GET_ALL_ROLE: any;
  public CREATE_ROLE_STATUS_PERMISSIONS: any;
  public UPDATE_ROLE_STATUS_PERMISSIONS: any;
  public GET_ALL_SCREEN: any;
  public UPDATE_ROLE_SCREEN_PERMISSIONS: any;
  public CREATE_ROLE_SCREEN_PERMISSIONS: any;
  public ALL_USERS: any;
  public GET_USER_BY_USER_ID: any;
  public GET_ROLE_BY_PERMISSION: any;
  public CREATE_USER_MENU_PERM: any;
  public CREATE_USER_STATUS_PERM: any;
  public UPDATE_USER_PRESET_PERM: any;
  public UPDATE_USER_STATUS_PERM: any;
  public UPDATE_USER_MENU_PERM: any;
  public FILTER_USER_BY_PRESET_PERMISSION: any
  public UPDATE_USER_AS_EXE_QUERY:any;

  constructor(public apollo: Apollo) {
    //get all roles
    this.GET_ALL_STATUS = gql`
    query GetStatuses($availableStatus:Boolean!) {
      allStatuses(filter: {availableStatus : {equalTo: $availableStatus}}) {
        nodes{
          statusId
          statusName
          availableStatus
          displayStatus
          roleStatusPermissionsByStatusId(filter: {isDeletedYn: {equalTo: false}}){
            nodes{
              roleId
              roleStatusPermissionId
              isDeletedYn
              roleByRoleId{
                roleName
              }
            }
          }
        }
      }
    }
     `
      ;

    this.GET_ALL_ROLE = gql`
    query GetRoles($isDeletedYn: Boolean!) {
      allRoles(filter: {isDeletedYn: {equalTo: $isDeletedYn}, roleDiv: {equalTo: true}, isshowsettingyn: {equalTo: true}}) {
        nodes {
          roleId
          roleName
          isDeletedYn
        }
      }
    }`;

    this.GET_ROLE_BY_PERMISSION = gql`
    query GetRoles($isDeletedYn: Boolean!) {
      allRoles(filter: {isDeletedYn: {equalTo: $isDeletedYn}, roleDiv: {equalTo: true}, isshowsettingyn: {equalTo: true}}) {
        nodes {
          roleId
          roleName
          isDeletedYn
          roleStatusPermissionsByRoleId(filter: {isDeletedYn: {equalTo: $isDeletedYn}}){
            nodes{
              roleStatusPermissionId
              statusId
              statusByStatusId{
                statusName
                displayStatus
              }
            }
          }
          roleScreenPermissonsByRoleId(filter: {isDeletedYn: {equalTo: $isDeletedYn}}) {
            nodes {
              menuItemId
              menuItemByMenuItemId {
                menuItemId
                menuItems
                title
                url
                path
              }
            }
          }
        }
      }
    }`;

    this.CREATE_ROLE_STATUS_PERMISSIONS = gql`
      mutation createRoleStatusPermission($input:CreateRoleStatusPermissionInput!) {
        createRoleStatusPermission(input:$input) {
             roleStatusPermission {
              roleStatusPermissionId
              roleId
              statusId
              isDeletedYn
              createdat
              updatedat
            }
          }
        }
     `
      ;

    this.UPDATE_ROLE_STATUS_PERMISSIONS = gql`
      mutation updateRoleStatusPermission($input:UpdateRoleStatusPermissionByRoleStatusPermissionIdInput!) {
        updateRoleStatusPermissionByRoleStatusPermissionId(input:$input) {
             roleStatusPermission{
             roleId
             statusId
             isDeletedYn
             createdat
             updatedat
            }
          }
        }
     `
      ;

    this.GET_ALL_SCREEN = gql`
    query MenuItems {
      allMenuItems(filter: {isDeletedYn: {equalTo: false}}) {
        nodes {
          menuItemId
          menuItems
          title
          url
          isDeletedYn
          createdAt
          updatedAt
          parentMenuItem
          roleScreenPermissonsByMenuItemId(filter: {isDeletedYn: {equalTo: false}}) {
            nodes {
              roleId
              roleScreenPermissonId
              isDeletedYn
              roleByRoleId {
                roleName
              }
            }
          }
        }
        totalCount
      }
    }

     `
      ;

    this.CREATE_ROLE_SCREEN_PERMISSIONS = gql`
      mutation createRoleScreenPermisson($input:CreateRoleScreenPermissonInput!) {
        createRoleScreenPermisson(input:$input) {
             roleScreenPermisson {
              roleScreenPermissonId
                 roleId
              menuItemId
              isDeletedYn
              createdAt
              updatedAt
            }
          }
        }
     `
      ;

    this.UPDATE_ROLE_SCREEN_PERMISSIONS = gql`
    mutation updateRoleScreenPermisson($input:UpdateRoleScreenPermissonByRoleScreenPermissonIdInput!) {
      updateRoleScreenPermissonByRoleScreenPermissonId(input:$input) {
           roleScreenPermisson{
            roleScreenPermissonId
              roleId
            menuItemId
            isDeletedYn
            createdAt
            updatedAt
          }
        }
      }
     `
      ;

    this.ALL_USERS = gql`
    query allUsers($limit: Int, $offset: Int) {
      allUsers(filter: {deleteUser: {isNull: true}, roleId: {notIn: ["8dab2f2a-2866-4527-9b3d-d2237d8d24c7", "fe66b505-c5dd-46a4-94ed-acb1fabbfaab"]}}, first: $limit, offset: $offset) {
        nodes {
          nodeId
          firstName
          lastName
          email
          userId
          roleId
          roleByRoleId {
            roleName
          }
          address
          phoneNumber
          deleteUser
          isDeactivateYn
        }
        totalCount
      }
    }`;

    this.GET_USER_BY_USER_ID = gql`
    query allUsers($userId: UUID!) {
      allUsers(filter: {deleteUser: {isNull: true}, userId: {equalTo: $userId}}) {
        nodes {
          nodeId
          firstName
          lastName
          email
          userId
          roleId
          roleByRoleId {
            roleName
          }
          address
          phoneNumber
          deleteUser
          userMenuPermissionsByUserId(filter: {isDeletedYn: {equalTo: false}}) {
            nodes {
              userMenuPermissionId
              userId
              menuItemId
            }
          }
          userStatusPermissionsByUserId(filter: {isDeletedYn: {equalTo: false}}) {
            nodes {
              userStatusPermissionId
              userId
              statusId
            }
          }
          presetPermRoleId
          isPresetPermCust
        }
        totalCount
      }
    }`;

    this.CREATE_USER_STATUS_PERM = gql`
    mutation createUserStatusPermission($input: CreateUserStatusPermissionInput!) {
      createUserStatusPermission(input: $input) {
        userStatusPermission {
          userStatusPermissionId
          userId
          statusId
          isDeletedYn
          createdAt
          updatedAt
        }
      }
    }`;

    this.CREATE_USER_MENU_PERM = gql`
    mutation createUserMenuPermission($input: CreateUserMenuPermissionInput!) {
      createUserMenuPermission(input: $input) {
        userMenuPermission {
          userMenuPermissionId
          userId
          menuItemId
          isDeletedYn
          createdAt
          updatedAt
        }
      }
    }`;

    this.UPDATE_USER_PRESET_PERM = gql`
    mutation updatecontact($input: UpdateUserByUserIdInput!) {
      updateUserByUserId(input: $input) {
        user{
          userId
          presetPermRoleId
        }
      }
    }`;

    this.UPDATE_USER_STATUS_PERM = gql`
    mutation updateUserStatusPermission($input: UpdateUserStatusPermissionByUserStatusPermissionIdInput!) {
      updateUserStatusPermissionByUserStatusPermissionId(input: $input) {
        userStatusPermission {
          userStatusPermissionId
          userId
          statusId
          isDeletedYn
          createdAt
          updatedAt
        }
      }
    }`;

    this.UPDATE_USER_MENU_PERM = gql`
    mutation updateUserMenuPermission($input: UpdateUserMenuPermissionByUserMenuPermissionIdInput!) {
      updateUserMenuPermissionByUserMenuPermissionId(input: $input) {
        userMenuPermission {
          userMenuPermissionId
          userId
          menuItemId
          isDeletedYn
          createdAt
          updatedAt
        }
      }
    }`;

    this.FILTER_USER_BY_PRESET_PERMISSION = gql`
    query filterExtPresetUserPermission($roleId: UUID!) {
      allUsers(filter: {presetPermRoleId: {equalTo: $roleId}, deleteUser: {isNull: true}, isPresetPermCust: {equalTo: false}}) {
        nodes {
          userId
          roleId
          firstName
          lastName
          isPresetPermCust
          presetPermRoleId
          userStatusPermissionsByUserId(filter: {isDeletedYn: {equalTo: false}}) {
            nodes {
              userStatusPermissionId
              userId
              statusId
            }
          }
          userMenuPermissionsByUserId(filter: {isDeletedYn: {equalTo: false}}){
            nodes{
              userMenuPermissionId
              menuItemId
              userId
            }
          }
        }
      }
    }`;

    this.UPDATE_USER_AS_EXE_QUERY = gql`mutation updateUserAsExecutive($input: UpdateUserByUserIdInput!){
      updateUserByUserId(input: $input){
        user{
          nodeId
          userId
          email
          password
          roleId
          firstName
          address
        }
      }
    }`;
  }

  GET_ALL_STATUSES(availableStatus) {
    return this.apollo.watchQuery({
      query: this.GET_ALL_STATUS,
      variables: {
        availableStatus: availableStatus
      },
      fetchPolicy: 'network-only'
    })
  }

  GET_ALL_ROLES(isDeletedYn) {
    return this.apollo.watchQuery({
      query: this.GET_ALL_ROLE,
      variables: {
        isDeletedYn: isDeletedYn
      },
      fetchPolicy: 'network-only'
    })
  }

  GET_ALL_ROLES_BY_PERMISSION(isDeletedYn) {
    return this.apollo.watchQuery({
      query: this.GET_ROLE_BY_PERMISSION,
      variables: {
        isDeletedYn: isDeletedYn
      },
      fetchPolicy: 'network-only'
    })
  }

  FILTER_USER_BY_PRESET_PERMISSION_FUN(roleId) {
    return this.apollo.watchQuery({
      query: this.FILTER_USER_BY_PRESET_PERMISSION,
      variables: {
        roleId: roleId
      },
      fetchPolicy: 'network-only'
    })
  }

  CREATE_ROLE_STATUS_PERMISSION(roleId, statusId) {
    return this.apollo.mutate({
      mutation: this.CREATE_ROLE_STATUS_PERMISSIONS,
      variables: {
        "input": {
          "roleStatusPermission": {
            "roleId": roleId,
            "statusId": statusId
          }
        }
      },
      fetchPolicy: 'no-cache'
    });
  }

  UPDATE_ROLE_STATUS_PERMISSION(roleId, statusId, roleStatusPermissionId) {
    return this.apollo.mutate({
      mutation: this.UPDATE_ROLE_STATUS_PERMISSIONS,
      variables: {
        "input": {
          "roleStatusPermissionId": roleStatusPermissionId,
          "roleStatusPermissionPatch": {
            "roleId": roleId,
            "statusId": statusId,
            "isDeletedYn": true,
            "updatedat": "now()"
          }
        }
      },
      fetchPolicy: 'no-cache'
    });
  }

  GET_ALL_SCREENS() {
    return this.apollo.watchQuery({
      query: this.GET_ALL_SCREEN,
      fetchPolicy: 'network-only'
    })
  }

  CREATE_ROLE_SCREEN_PERMISSION(roleId, menuItemId) {
    return this.apollo.mutate({
      mutation: this.CREATE_ROLE_SCREEN_PERMISSIONS,
      variables: {
        "input": {
          "roleScreenPermisson": {
            "roleId": roleId,
            "menuItemId": menuItemId
          }
        }
      },
      fetchPolicy: 'no-cache'
    });
  }

  UPDATE_ROLE_SCREEN_PERMISSION(roleId, menuItemId, roleScreenPermissonId) {
    return this.apollo.mutate({
      mutation: this.UPDATE_ROLE_SCREEN_PERMISSIONS,
      variables: {
        "input": {
          "roleScreenPermissonId": roleScreenPermissonId,
          "roleScreenPermissonPatch": {
            "roleId": roleId,
            "menuItemId": menuItemId,
            "isDeletedYn": true,
            "updatedAt": "now()"
          }
        }
      },
      fetchPolicy: 'no-cache'
    });
  }

  GET_ALL_USERS(payload) {
    return this.apollo.watchQuery({
      query: this.ALL_USERS,
      variables: payload,
      fetchPolicy: 'network-only'
    })
  }

  GET_USER_BY_USER_ID_FUN(payload) {
    return this.apollo.watchQuery({
      query: this.GET_USER_BY_USER_ID,
      variables: payload,
      fetchPolicy: 'network-only'
    })
  }

  CREATE_USER_STATUS_PERMISSION(userId, statusId, roleId) {
    return this.apollo.mutate({
      mutation: this.CREATE_USER_STATUS_PERM,
      variables: {
        "input": {
          "userStatusPermission": {
            "userId": userId,
            "statusId": statusId,
            "presetPermRoleId": roleId
          }
        }
      },
      fetchPolicy: 'no-cache'
    });
  }

  CREATE_USER_MENU_PERMISSION(userId, menuItemId, roleId) {
    return this.apollo.mutate({
      mutation: this.CREATE_USER_MENU_PERM,
      variables: {
        "input": {
          "userMenuPermission": {
            "userId": userId,
            "menuItemId": menuItemId,
            "presetPermRoleId": roleId
          }
        }
      },
      fetchPolicy: 'no-cache'
    });
  }

  UPDATE_USER_PRESET_PERMISSION(userId, presetPermRoleId, isPresetPermCust) {
    return this.apollo.mutate({
      mutation: this.UPDATE_USER_PRESET_PERM,
      variables: {
        "input": {
          "userId": userId,
          "userPatch": {
            "presetPermRoleId": presetPermRoleId,
            "isPresetPermCust": isPresetPermCust
          }
        }
      },
      fetchPolicy: 'no-cache'
    });
  }

  UPDATE_USER_AS_DEACTIVATE(userId, isDeactivate) {
    return this.apollo.mutate({
      mutation: this.UPDATE_USER_PRESET_PERM,
      variables: {
        "input": {
          "userId": userId,
          "userPatch": {
            "isDeactivateYn": isDeactivate,
          }
        }
      },
      fetchPolicy: 'no-cache'
    });
  }


  UPDATE_USER_STATUS_PERMISSION(userStatusPermissionId) {
    return this.apollo.mutate({
      mutation: this.UPDATE_USER_STATUS_PERM,
      variables: {
        "input": {
          "userStatusPermissionId": userStatusPermissionId,
          "userStatusPermissionPatch": {
            "isDeletedYn": true,
          }
        }
      },
      fetchPolicy: 'no-cache'
    });
  }

  UPDATE_USER_MENU_PERMISSION(userMenuPermissionId) {
    return this.apollo.mutate({
      mutation: this.UPDATE_USER_MENU_PERM,
      variables: {
        "input": {
          "userMenuPermissionId": userMenuPermissionId,
          "userMenuPermissionPatch": {
            "isDeletedYn": true,
          }
        }
      },
      fetchPolicy: 'no-cache'
    });
  }

  UPDATE_USER_AS_EXECU_CALL(userId, roleId) {
    return this.apollo.mutate({
      mutation: this.UPDATE_USER_AS_EXE_QUERY,
      variables: {
        "input": {
          "userId": userId,
          "userPatch": {
            "roleId": roleId
          }
        }
      },
      fetchPolicy: 'no-cache'
    });
  }

}



// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/queryFiles/permission.ts